import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Award } from 'lucide-react';

const Hero = () => {
  return (
    <section className="min-h-[80vh] bg-black relative overflow-hidden pt-24 flex items-center">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black to-neutral-950" />
      
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-[0.02]" 
        style={{
          backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
          backgroundSize: '100px 100px'
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        {/* Award Badge */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2">
            <Award className="w-4 h-4 text-yellow-500" />
            <span className="text-white/80 text-sm">Webby's Anthem Award 2022 Gold Winner</span>
          </div>
        </div>

        {/* Main Headline */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight max-w-5xl mx-auto">
            From idea to investable AI startup—in under 30 days.
          </h1>
          <p className="text-xl md:text-2xl text-white/60 max-w-3xl mx-auto leading-relaxed">
            We help founders sculpt the right idea, build a working AI proof of concept, and package it into a raise-ready story investors can believe.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            className="bg-white text-black hover:bg-white/90 rounded-full px-8 py-6 text-lg font-medium group"
            onClick={() => window.open('https://calendly.com/superboonie', '_blank')}
          >
            Setup a Call
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-white/30 text-white hover:bg-white/10 hover:border-white/50 rounded-full px-8 py-6 text-lg font-medium bg-white/5"
            onClick={() => document.getElementById('work')?.scrollIntoView({ behavior: 'smooth' })}
          >
            View Our Work
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;